import { render, staticRenderFns } from "./StandardTable.vue?vue&type=template&id=22ceef3e&scoped=true"
import script from "./StandardTable.vue?vue&type=script&lang=js"
export * from "./StandardTable.vue?vue&type=script&lang=js"
import style0 from "./StandardTable.vue?vue&type=style&index=0&id=22ceef3e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ceef3e",
  null
  
)

export default component.exports